import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=33adc481&scoped=true"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"
import style0 from "./activate.vue?vue&type=style&index=0&id=33adc481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adc481",
  null
  
)

export default component.exports